"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.PhotoWrapper = exports.IconWrapper = exports.Icon = exports.GreetingMessageAndContact = exports.GreetingMessage = exports.BannerDialog = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  textAlign: 'center'
}));
const GreetingMessageAndContact = exports.GreetingMessageAndContact = (0, _mui.styled)('div')(({
  theme
}) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  padding: theme.spacing(2),
  width: '100%',
  '&:empty': {
    display: 'none'
  }
}));
const GreetingMessage = exports.GreetingMessage = (0, _mui.styled)(_mui.Typography, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['shouldHaveMarginTop'])
})(({
  shouldHaveMarginTop,
  theme
}) => ({
  marginTop: shouldHaveMarginTop ? theme.spacing(2) : 0,
  strong: {
    display: 'block',
    marginTop: theme.spacing(2)
  }
}));
const Icon = exports.Icon = (0, _mui.styled)(_icons.GiftFilled)(({
  theme
}) => ({
  color: theme.palette.offer.main
}));
const IconWrapper = exports.IconWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  backgroundColor: theme.palette.offer.light,
  borderRadius: 20,
  height: 40,
  width: 40
}));
const BannerDialog = exports.BannerDialog = (0, _mui.styled)(_components.Dialog)(({
  theme
}) => ({
  [`& .${_mui.paperClasses.root}`]: {
    [theme.breakpoints.up('sm')]: {
      width: 390
    }
  }
}));
const PhotoWrapper = exports.PhotoWrapper = (0, _mui.styled)('div')(({
  theme
}) => ({
  borderRadius: 100,
  height: 40,
  margin: 'auto',
  overflow: 'hidden',
  width: 40
}));
